import React, { useEffect, useState } from 'react'
import {
  fetchPetTypes,
  insertPetType,
  updatePetType,
  deletePetType,
} from './pettype.js'

const PetTypesManager = () => {
  const [categories, setCategories] = useState([])
  const [filteredType, setFilteredType] = useState(null)
  const [formData, setFormData] = useState({
    pet_type: '',  name: '',  // Add this

  })
  const [editId, setEditId] = useState(null)

  const loadCategories = async () => {
    try {
      const data = await fetchPetTypes()
      setCategories(data)
    } catch (err) {
      console.error('Error loading categories:', err.message)
    }
  }

  useEffect(() => {
    loadCategories()
  }, [])

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      if (editId) {
        await updatePetType(editId, formData)
        setEditId(null)
      } else {
        await insertPetType(formData)
      }
setFormData({ pet_type: '', name: '' })
      await loadCategories()
    } catch (err) {
      console.error('Error saving pet type:', err.message)
    }
  }

const handleEdit = (category) => {
  setEditId(category.id)
  setFormData({ pet_type: category.pet_type, name: category.name || '' })
}

  const handleDelete = async (id) => {
    try {
      await deletePetType(id)
      await loadCategories()
    } catch (err) {
      console.error('Error deleting pet type:', err.message)
    }
  }

  const uniquePetTypes = [...new Set(categories.map((c) => c.pet_type))]
  const filteredList = filteredType
    ? categories.filter((c) => c.pet_type === filteredType)
    : categories

  return (
    <div className="max-w-6xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4 text-center">🐾 Gestion des types d'animaux🐾</h2>

      {/* Form */}
      <form
        onSubmit={handleSubmit}
        className="bg-white shadow rounded-lg p-6 mb-6 border"
      >
        <input
          className="border border-gray-300 rounded px-3 py-2 w-full sm:w-1/2"
          type="text"
          name="pet_type"
          value={formData.pet_type}
          placeholder="Pet Type (e.g. chat, chien)"
          onChange={handleChange}
          required
        />
        <input
  className="border border-gray-300 rounded px-3 py-2 w-full sm:w-1/2 mb-2"
  type="text"
  name="name"
  value={formData.name}
  placeholder="Category Name"
  onChange={handleChange}
  required
/>

 <button
  type="submit"
  className="ml-4 mt-2 sm:mt-0 bg-gray-500 text-black  color:black px-4 py-2 rounded hover:bg-gray-600 transition"
>
  {editId ? 'Update' : 'Add'} Pet Type
</button>

      </form>

      {/* Filter Buttons */}
      <div className="flex flex-wrap gap-2 justify-center mb-6">
        {uniquePetTypes.map((type) => (
          <button
            key={type}
            onClick={() => setFilteredType(filteredType === type ? null : type)}
            className={`px-4 py-2 rounded-full text-sm border ${
              filteredType === type
                ? 'bg-green-600 text-black border-green-600'
                : 'bg-white text-gray-700 border-gray-300'
            } hover:bg-green-100 transition`}
          >
            {type}
          </button>
        ))}
      </div>

{/* Grid Cards */}
{/* Grid Cards - horizontal scroll */}
<div className="flex gap-4 overflow-x-auto pb-4">
  {filteredList.map((category) => (
    <div
      key={category.id}
      className="bg-white border rounded-xl p-3 shadow-sm flex flex-col items-center text-center text-sm min-w-[180px]"
      style={{ flex: '0 0 auto' }} // prevent shrinking, keep fixed width
    >
      <h4 className="text-md font-semibold capitalize mb-1">{category.name}</h4>
      <p className="text-xs text-gray-500 italic mb-3">
        Type: {category.pet_type}
      </p>
      <div className="flex space-x-4 mt-auto justify-center text-xl cursor-pointer select-none">
        {/* Edit icon button (emoji) */}
        <button
          onClick={() => handleEdit(category)}
          aria-label="Edit"
          className="text-blue-600 hover:text-blue-800 transition"
        >
          ✏️
        </button>

        {/* Delete icon button (emoji) */}
        <button
          onClick={() => handleDelete(category.id)}
          aria-label="Delete"
          className="text-red-600 hover:text-red-800 transition"
        >
          🗑️
        </button>
      </div>
    </div>
  ))}
</div>



    </div>
  )
}

export default PetTypesManager
